import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBBPoUzlJ0atYcEQlewCukFEnnB3-dLL4w",
  authDomain: "starmart-61ffe.firebaseapp.com",
  projectId: "starmart-61ffe",
  storageBucket: "starmart-61ffe.firebasestorage.app",
  messagingSenderId: "958656895984",
  appId: "1:958656895984:web:39089612ca69bbc2c39b35"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
